import React from 'react';

const HelpComponent: React.FC = () => {
    return (
      <div
        className="help-component-container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: '20px',
        }}
      >
        <div className="help-component">
          <img 
            src="/ooevv.png" 
            alt="OOEVV Logo" 
            style={{
              maxWidth: '30%',
              height: 'auto',
              marginBottom: '20px',
            }}
          />
          <h1>OOEVV Webboard</h1>
          <p>The Web Departureboard (also called Passenger Information System) displays a version of the OOEVV timetable with a reduced feature set. It is primarily used by external customers in the browser.</p>
          <h2>Available Parameters:</h2>
          <ul>
            <li><strong>extid</strong>: External ID (required) - Format: 2 digits for state, 5 for stop ID, 2 for platform (00 for entire stop)</li>
            <li><strong>product</strong>: Product filter (optional) - Use binary OR | for multiple</li>
            <li><strong>direction</strong>: Direction filter (optional)</li>
            <li><strong>line</strong>: Line filter (optional)</li>
            <li><strong>track</strong>: Platform/Track filter (optional)</li>
            <li><strong>displaytrack</strong>: Display Track (true/false)</li>
            <li><strong>token</strong>: Authorization token (required in request header 'Authorization: bearer TOKEN' or as query parameter 'token=TOKEN')</li>
            <li><strong>isarrivalboard</strong>: Is Arrival Board (presence of parameter sets to true)</li>
          </ul>
          <h2>Sample URLs:</h2>
          <ul>
            <li>Basic with header authorization: https://webboard.dfi-ooevg.at/?extid=444774700</li>
            <li>Basic with query parameter authorization: https://webboard.dfi-ooevg.at/?extid=444774700&token=TOKENVALUE</li>
            <li>Train only: https://webboard.dfi-ooevg.at/?extid=444774700&product=1</li>
            <li>Bus only: https://webboard.dfi-ooevg.at/?extid=444774700&product=64</li>
            <li>Train and Bus: https://webboard.dfi-ooevg.at/?extid=444774700&product=1|64</li>
            <li>Line filter: https://webboard.dfi-ooevg.at/?extid=444774700&line=315</li>
            <li>Display Track: https://webboard.dfi-ooevg.at/?extid=444774700&displaytrack=true</li>
            <li>Display ArrivalBoard: https://webboard.dfi-ooevg.at/?extid=444774700&isArrivalBoard</li>
          </ul>
          <p>Note: A valid token must be set in the request header for Authorization, or "no data" will be displayed.</p>
        </div>
      </div>
    );
  };

  export default HelpComponent;